export class File {
    id: string;
    file_fullname: string;
    file_name: string;
    file_type: string;
    file_size: number;
    extension: string;
    is_image: boolean;
    is_resizable: boolean;
    // description?: any;
    _joinData: any;

    constructor(options: {
        id: string,
        file_fullname: string,
        file_name: string,
        file_type: string,
        file_size: number,
        extension: string,
        is_image: boolean,
        is_resizable: boolean,
        // description?: any,
        _joinData: any
    }) {
        this.id = options.id;
        this.file_fullname = options.file_fullname;
        this.file_name = options.file_name;
        this.file_type = options.file_type;
        this.file_size = options.file_size;
        this.extension = options.extension;
        this.is_image = options.is_image;
        this.is_resizable = options.is_resizable;
        // if (options.description) {
        //     this.description = options.description;
        // }
        this._joinData = options._joinData;
    }
}
